<script>
  import Piebk from "../components/graph/PieCumulBk.svelte";
  import Chartbenef from "../components/graph/GraphCumulByBenef.svelte";
</script>

<div class="container-fluid">
  <div class="chart-wrapper">
    <Piebk />
  </div>

  <div class="chart-wrapper">
    <Chartbenef />
  </div>
</div>

<style>
  .chart-wrapper {
    height: 90%;
    width: 480px;
  }
  .container-fluid{
        width: 100%;
	    margin: auto;
  }

</style>
